module.exports = __webpack_public_path__ + "static/Planet_4-823cdf1a449e98456fa6ddb7ca2d675b.png";